<template>
  <div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="el-icon-s-home"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>用户中心</el-breadcrumb-item>
        <el-breadcrumb-item>订单详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="wrapper">
      <div class="sidebar">
        <div class="avatar">
          <img src="../../assets/images/avatar.jpg" />
          <div class="name">
            <!--<h3>张明翰</h3>-->
            <p>{{ phoneNumShow() }}</p>
          </div>
        </div>
        <ul class="menu">
          <li>
            <router-link to="/account/ticket-order">
              <img src="../../assets/images/icon-order.png" />
              <span>票务订单</span>
            </router-link>
          </li>
          <li class="active">
            <router-link to="/account/mall-order">
              <img src="../../assets/images/icon-order-active.png" />
              <span>商城订单</span>
            </router-link>
          </li>
          <li>
            <router-link to="/account/contacts">
              <img src="../../assets/images/icon-contacts.png" />
              <span>常用联系人</span>
            </router-link>
          </li>
          <!--
          <li>
            <router-link to="/account/profile">
              <img src="../../assets/images/icon-profile.png" />
              <span>个人资料</span>
            </router-link>
          </li>-->
        </ul>
      </div>
      <div class="main">
        <div class="order-title">
          <h2>订单详情</h2>
          <!--<router-link to="./">&lt; 返回列表</router-link>-->
          <a @click="goOrderList">&lt; 返回列表</a>
        </div>
        <div class="order-detail">
          <div class="content">
            <div class="bGColorWhite">
              <div class="title">订单信息</div>
              <div class="flex-justify">订单编号：{{ goodsDetail.code }}</div>
              <div class="flex-justify">
                下单时间：{{ goodsDetail.timestamp }}
              </div>
            </div>
            <div class="bGColorWhite padding-b-10">
              <div class="title">收货地址</div>
              <div class="flex-justify">
                <div class="name">姓名：</div>
                <div class="input-box">
                  <p v-if="goodsDetail.extm_info">
                    {{ goodsDetail.extm_info.consignee }}
                  </p>
                </div>
              </div>
              <div class="flex-justify">
                <div class="name">手机号：</div>
                <div class="input-box">
                  <p v-if="goodsDetail.extm_info">
                    {{ goodsDetail.extm_info.phone_mob }}
                  </p>
                </div>
              </div>
              <div class="flex-justify">
                <div class="name">地址：</div>
                <div class="input-box">
                  <p v-if="goodsDetail.extm_info">
                    {{ goodsDetail.extm_info.address }}
                  </p>
                </div>
              </div>
            </div>
            <div class="bGColorWhite">
              <div class="title">订单详情</div>
              <ul class="order-goods">
                <li
                  v-for="(goodsItem, goodsIndex) in goodsDetail.goods"
                  :key="goodsIndex"
                >
                  <img :src="allImageUrl(goodsItem.goods_img)" />
                  <div class="goods-text">
                    <h3>{{ goodsItem.goods_name }}</h3>
                    <div v-if="goodsItem.spec_qty == 1">
                      <p>
                        {{ goodsItem.spec_info.spec_k1 }}:{{
                          goodsItem.spec_info.spec_v1
                        }}
                      </p>
                    </div>
                    <div v-if="goodsItem.spec_qty == 2">
                      <p>
                        {{ goodsItem.spec_info.spec_k1 }}:{{
                          goodsItem.spec_info.spec_v1
                        }}
                      </p>
                      <p>
                        {{ goodsItem.spec_info.spec_k2 }}:{{
                          goodsItem.spec_info.spec_v2
                        }}
                      </p>
                    </div>
                  </div>
                  <div>￥{{ goodsItem.goods_price }}</div>
                  <div>x {{ goodsItem.goods_num }}</div>
                </li>
              </ul>
              <!-- <div
                class="flex-justify"
                v-for="(goodsItem, goodsIndex) in goodsDetail.goods"
                :key="goodsIndex"
              >
                <div class="img">
                  <img :src="allImageUrl(goodsItem.goods_img)" alt="" />
                </div>
                <div class="text">
                  <div>{{ goodsItem.goods_name }}</div>
                  <div class="flex-justify" v-if="goodsItem.spec_qty == 1">
                    <div>
                      {{ goodsItem.spec_info.spec_k1 }}:
                      {{ goodsItem.spec_info.spec_v1 }}
                    </div>
                  </div>
                  <div class="flex-justify" v-if="goodsItem.spec_qty == 2">
                    <div>
                      {{ goodsItem.spec_info.spec_k1 }}:
                      {{ goodsItem.spec_info.spec_v1 }}
                    </div>
                    <div>
                      {{ goodsItem.spec_info.spec_k2 }}:
                      {{ goodsItem.spec_info.spec_v2 }}
                    </div>
                  </div>
                  <div class="flex-justify">
                    <div>
                      价格：
                      <div class="red">￥{{ goodsItem.goods_price }}</div>
                    </div>
                    <div>数量：{{ goodsItem.goods_num }}</div>
                  </div>
                </div>
              </div> -->
            </div>
            <div class="padding-b-10">
              <div class="title">费用详情</div>
              <div class="flex-justify" style="justify-content: space-between">
                <div class="img">商品总金额</div>
                <div class="red">￥{{ goodsDetail.goods_only_amount }}</div>
              </div>
              <div class="flex-justify" style="justify-content: space-between">
                <div class="img">运费金额</div>
                <div class="red">￥{{ goodsDetail.shipping_fee }}</div>
              </div>
              <div class="flex-justify" style="justify-content: space-between">
                <div class="img">实付款(含运费)</div>
                <div class="red">￥{{ goodsDetail.goods_amount }}</div>
              </div>
            </div>
            <div class="bGColorWhite padding-b-10">
              <div class="title">订单跟踪</div>
              <div style="padding: 10px 10px">
                <steps
                  v-for="(oItem, oIndex) in mallOrderLogList"
                  :item="oItem"
                  :pIndex="oIndex"
                  :key="oIndex"
                ></steps>
              </div>
            </div>
            <div class="order-total">
              <div class="right-button" v-if="goodsDetail.status == 0">
                <span class="btn-gray" @click="deleteOrder(goodsDetail.code)">
                  删除订单
                </span>
              </div>
              <div
                class="right-button"
                v-if="goodsDetail.status == 10 || goodsDetail.status == 11"
              >
                <span class="btn-gray" @click="cancelOrder(goodsDetail.code)">
                  取消订单
                </span>
                <span class="btn-green" @click="goPay()"> 去支付 </span>
              </div>
              <div class="right-button" v-if="goodsDetail.status == 30">
                <span
                  class="btn-green"
                  @click="takeOverOrder(goodsDetail.code)"
                >
                  确认收货
                </span>
              </div>
              <div class="text">共1笔订单</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <new-pay-pouup
      :payDialogShow="payQrCode"
      :orderId="goodsDetail.code"
      :orderAmount="goodsDetail.amount"
      v-on:payPrenterShow="payPrenterShow"
      comeFrom="mall"
    ></new-pay-pouup>
    <el-dialog
      title="取消提示"
      :visible.sync="cancelDialogVisible"
      width="30%"
      :before-close="cancelHandleClose"
    >
      <p>您确定要取消该订单么？</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="cancelOrderConfirm">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="删除订单提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <p>您确定要删除该订单吗？</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="refundOrderConfirm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import mall from '@/api/mall';
import { getImageAllUrl, phoneHidden } from '@/setup/common';
import user from '@/setup/user';
import NewPayPouup from '@/components/NewPayPouup.vue';
import steps from '@/components/pretty-steps/pretty-steps.vue';
export default {
  components: {
    NewPayPouup,
    steps,
  },
  data() {
    return {
      payQrCode: false,
      goodsDetail: {},
      goodsNewSkuName: '',
      allAmount: '0.00',
      orderCode: '',
      dialogVisible: false,
      cancelDialogVisible: false,
      mallOrderLogList: [],
    };
  },
  created() {
    this.orderCode = this.$route.query.orderCode;
    this.getMallOrderDetailInfo();
  },
  methods: {
    phoneNumShow() {
      let currentUser = user.getUser();
      if (currentUser != null) {
        let phone = phoneHidden(currentUser.phone);
        return phone;
      }
    },
    payPrenterShow() {
      this.payQrCode = false;
      this.$router.go(-1);
    },
    getMallOrderDetailInfo() {
      this.getMallOrderDetail();
      this.getOrderLogList();
    },
    cancelHandleClose() {
      this.cancelDialogVisible = false;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    async getMallOrderDetail() {
      const mallOrderDetail = await mall.getOrderDetail({
        order_code: this.orderCode,
      });
      this.goodsDetail = mallOrderDetail;
      console.log('商城订单详情是剁手', mallOrderDetail);
    },
    async getOrderLogList() {
      const mallOrderLogList = await mall.getOrderLogList({
        order_code: this.orderCode,
      });
      this.mallOrderLogList = mallOrderLogList;
      console.log('订单log是', mallOrderLogList);
    },
    allImageUrl(string) {
      return getImageAllUrl(string);
    },
    goPay() {
      this.payQrCode = true;
    },
    goOrderList() {
      /*routerTo.toOrderList(this.$router, false);*/
      this.$router.go(-1);
    },
    deleteOrder(orderCode) {
      this.orderCode = orderCode;
      this.dialogVisible = true;
    },
    refundOrderConfirm() {
      this.getDeleteOrder();
    },
    cancelOrder(orderCode) {
      this.orderCode = orderCode;
      this.cancelDialogVisible = true;
    },
    cancelOrderConfirm() {
      this.getCancelOrder();
    },
    async getDeleteOrder() {
      const DeleteOrder = await mall.getDeleteOrder({
        order_code: this.orderCode,
      });
      this.dialogVisible = false;
      this.$router.go(-1);
    },
    async getCancelOrder() {
      const cancelOrder = await mall.getCancelOrder({
        order_code: this.orderCode,
      });
      this.cancelDialogVisible = false;
      this.getMallOrderDetailInfo();
    },
    async getRemindOrder() {
      //提醒发货
      const remind = await mall.getRemindOrder({
        order_code: this.orderCode,
      });
      this.getMallOrderDetailInfo();
    },
    async takeOverOrder(code) {
      const re = await mall.getTakeOverOrder({
        order_code: code,
      });
      alert('确认收货成功');
      this.getMallOrderDetailInfo();
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  display: flex;
  justify-content: space-between;
  width: 1100px;
  margin: 0 auto;
  padding: 20px 0;
  text-align: left;
  .sidebar {
    width: 280px;
    padding: 20px 0;
    border-radius: 10px;
    background: #fff;
    .avatar {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      padding: 0 30px;
      .name {
        margin-left: 16px;
        h3 {
          margin-bottom: 5px;
          font-size: 18px;
        }
      }
    }
    .menu {
      li {
        height: 50px;
        padding: 0 0 0 30px;
        font-size: 16px;
        line-height: 50px;
        a {
          display: block;
          color: #191b26;
        }
        img {
          width: 24px;
          height: 24px;
          margin-right: 10px;
        }
      }
      li.active {
        border-right: 2px solid #31a775;
        color: #31a775;
        background: #f6fcf9;
        a {
          color: #31a775;
        }
      }
    }
  }
  .main {
    width: 800px;
    .order-title {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      border-bottom: 1px solid #eee;
      line-height: 40px;
      h2 {
        border-bottom: 2px solid #31a775;
        color: #31a775;
        font-weight: normal;
        font-size: 16px;
      }
      a {
        color: #31a775;
        font-size: 16px;
        cursor: pointer;
      }
    }
    .order-detail {
      border-radius: 10px;
      background: #fff;
      .info {
        padding: 20px 20px;
        .time {
          display: flex;
          justify-content: space-between;
          margin-bottom: 6px;
        }
        h3 {
          color: #191b26;
          font-size: 16px;
        }
        p span {
          margin-left: 6px;
          font-size: 20px;
        }
        .number {
          display: flex;
          align-items: flex-end;
          justify-content: space-between;
          color: #515457;
        }
        .price {
          padding-bottom: 10px;
        }
        .price span {
          margin-left: 6px;
          color: #f15b49;
          font-size: 20px;
        }
        .status {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        a {
          margin-left: 10px;
        }
        .button {
          display: inline-block;
          padding: 6px 16px;
          border-radius: 18px;
          color: #fff;
          background: #31a775;
          cursor: pointer;
        }
        .completed {
          color: #31a775;
        }
        .unpaid {
          color: #f15b49;
        }
        .cancelled {
          color: #9e9e9e;
        }
        img {
          width: 20px;
          height: 20px;
          margin-right: 2px;
        }
      }
    }
    .unpaid-bar {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-top: 10px;
      padding: 20px 20px;
      border-radius: 10px;
      background: #fff;
      p {
        font-size: 16px;
        span {
          color: #f15b49;
          font-weight: bold;
        }
      }
      .button {
        display: inline-block;
        width: 88px;
        margin-left: 40px;
        padding: 6px 16px;
        border-radius: 18px;
        color: #fff;
        line-height: 24px;
        text-align: center;
        background: #31a775;
        cursor: pointer;
      }
    }
  }
}
.order-goods {
  padding: 10px 0;
  li {
    display: flex;
    margin-bottom: 0;
    padding: 10px 20px;
    img {
      width: 80px;
      height: 80px;
      margin-right: 20px;
    }
    .goods-text {
      width: 280px;
    }
    h3 {
      margin-bottom: 6px;
      font-weight: normal;
      font-size: 14px;
    }
    div {
      margin-right: 100px;
    }
  }
}
.order-total {
  padding: 20px 20px;
  border-top: 1px solid #eee;
  .right-button {
    float: right;
    .btn-green,
    .btn-gray {
      margin-left: 20px;
      padding: 8px 22px;
      border-radius: 16px;
      color: #fff;
      background: #31a775;
      cursor: pointer;
    }
    .btn-gray {
      background: #bbbbbb;
    }
  }
}

.padding-t-10 {
  padding-top: 10px;
}
.margin-b-20 {
  margin-bottom: 20px;
  background-color: #fff;
}
.bGColorWhite {
  background-color: #fff;
}
.margin-b-100 {
  margin-bottom: 100px;
  background-color: #fff;
}
.margin-l-10 {
  margin-left: 10px;
}
.title {
  margin-bottom: 10px;
  padding: 0 20px;
  border-bottom: 1px solid #eee;
  font-weight: bold;
  line-height: 40px;
}
.flex-justify {
  display: flex;
  padding: 7px 20px;
  line-height: 20px;
  .name {
    width: 100px;
  }
  .input-box {
    flex: 1;
  }
  .img {
    width: 200px;
    img {
      max-width: 100%;
      height: 200px;
    }
  }
  .text {
    flex: 1;
  }
}
.red {
  display: inline-block;
}
.padding-b-10 {
  padding-bottom: 10px;
}
</style>
